import React from "react"
import tw from "twin.macro"
import { Typography } from "../components/Typography"
import { Layout } from "../components/Layout"
import { graphql, Link } from "gatsby"
import { Separator } from "../components/Separator"
import { Heading } from "../components/Heading"

export default function Articles({ data }: { data: QueryResult }) {
  return (
    <Layout>
      <Heading title="ARTICLES" />
      {data.allMdx.edges.map((edge, index, array) => (
        <>
          <Link key={edge.node.id} to={`/${edge.node.slug}`}>
            <ArticleListItem
              title={edge.node.frontmatter.title}
              date={edge.node.frontmatter.date}
              excerpt={edge.node.excerpt}
            />
          </Link>
          {index < array.length - 1 && <Separator css={tw`w-full`} />}
        </>
      ))}
    </Layout>
  )
}

const ArticleListItem = ({
  title,
  date,
  excerpt,
}: {
  title: string
  date: string
  excerpt: string
}) => {
  return (
    <div css={tw`my-4`}>
      <Typography variant="itemTitle">{title}</Typography>
      <Typography variant="small" css={tw`text-gray-medium mb-1`}>
        {date}
      </Typography>
      <Typography variant="body">{excerpt}</Typography>
    </div>
  )
}

type QueryResult = {
  allMdx: {
    totalCount: number
    edges: Array<{
      node: {
        id: string
        frontmatter: {
          title: string
          date: string
        }
        excerpt: string
        slug: string
      }
    }>
  }
}

export const query = graphql`
  query {
    allMdx(sort: { fields: frontmatter___date, order: DESC }) {
      totalCount
      edges {
        node {
          id
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
          }
          excerpt
          slug
        }
      }
    }
  }
`
